module.exports = __webpack_public_path__ + "media/images/promo/app-61ce251654b3f4b5ebf0f02d639be5a4b8e6f987845d0345b796ac69d45ec4e8.png";